<template>
  <section class="intent-registration-credit" v-loading="loading">
    <el-alert v-if="error" :title="error" type="error" :closable="false"><el-button type="text" @click="load">重新加载意向金关联</el-button></el-alert>
    <template v-if="credit">
      <h4>关联意向金与抵扣记录</h4>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="意向金订单">{{ credit.intentOrderNo || credit.intentOrderId }}</el-descriptions-item>
        <el-descriptions-item label="抵扣状态">{{ stateLabel(couponStates, credit.couponState) }}</el-descriptions-item>
        <el-descriptions-item label="原报名总费用">¥{{ money(credit.grossAmount) }}</el-descriptions-item>
        <el-descriptions-item label="本次意向金抵扣">¥{{ money(credit.intentAmount) }}</el-descriptions-item>
        <el-descriptions-item label="本次应付现金">¥{{ money(credit.cashDue) }}</el-descriptions-item>
        <el-descriptions-item label="凭证记载金额合计">¥{{ money(credit.recordedCashAmount) }}（不表示全部已核验）</el-descriptions-item>
      </el-descriptions>
      <p>关联只锁定意向金；沿原审核完成后核销，不在关联时升级身份或额外充值。</p>
      <el-table :data="credit.logs || []" border size="small">
        <el-table-column label="时间 / 操作人" min-width="180"><template slot-scope="{row}">{{ time(row.occurredAt) }}<p>{{ row.operatorName || '-' }}</p></template></el-table-column>
        <el-table-column label="流程操作" min-width="180"><template slot-scope="{row}">{{ row.actionName || action(row.action, row.targetType) }}<p>{{ row.beforeState || '-' }} → {{ row.afterState || '-' }}</p></template></el-table-column>
        <el-table-column label="金额" width="100"><template slot-scope="{row}">{{ row.amount == null ? '-' : '¥' + money(row.amount) }}</template></el-table-column>
        <el-table-column prop="remark" label="依据 / 结果" min-width="220" />
      </el-table>
    </template>
  </section>
</template>
<script>
import api from '@/api/live/intentDeposit'
import { intentTime, intentMoney, intentAction, intentStateLabel, couponStates, hasIntentPermission } from '@/utils/intent-deposit'
// 与后端 IntentFinanceRegistrationService.credit 的查看权限一致；没有权限的审核人不请求，免得每次都看到一条权限报错
const viewPermissions = ['intent:order:view', 'intent:join:review', 'customer:identity:first', 'customer:identity:last']
export default {
  props: { registrationId: [String, Number] },
  data() { return { loading: false, error: '', credit: null, sequence: 0 } },
  watch: { registrationId: { immediate: true, handler() { this.load() } } },
  beforeDestroy() { ++this.sequence },
  methods: {
    time: intentTime, money: intentMoney, action: intentAction, stateLabel: intentStateLabel,
    async load() {
      const sequence = ++this.sequence, id = this.registrationId
      this.credit = null; this.error = ''; this.loading = false
      if (!id || !viewPermissions.some(p => hasIntentPermission(this.$store, p))) return
      this.loading = true
      try { const response = await api.registrationCredit(String(id)); if (sequence === this.sequence) this.credit = response.data || null }
      catch (error) { if (sequence === this.sequence) this.error = error.message || '意向金关联加载失败，请核对后审核' }
      finally { if (sequence === this.sequence) this.loading = false }
    }
  },
  computed: { couponStates() { return couponStates } }
}
</script>
<style scoped>.intent-registration-credit { margin: 14px 0; } p { margin: 6px 0; font-size: 12px; color: #606266; }</style>
